import React from 'react';

const About = () => (
  <div className="about">
    <h1>Sum.</h1>
    <p>Some guy once said something like "What gets measured, gets managed". For people having trouble managing their personal finances, simply measuring their income and expenses is the first step. Often just the act of knowing where your money is going brings about the motivation to make changes. Sum. is a very simple app that gives the user a lot of freedom in simply measuring. Create any number of custom categories for income and expenses. Then watch where the money goes. Once you actually see how your expenses add up it will almost be harder not to make any changes.</p>
  </div>
)

export default About;
